import { ChangeDetectorRef, Directive, ElementRef, Input } from '@angular/core';
import { google } from 'google-maps';
declare var google: google;

@Directive({
    selector: '[octoGooglePlacesAutocomplete]',
    standalone: false,
})
export class GooglePlacesAutocompleteDirective {
    @Input() octoGooglePlacesAutocomplete: any;

    constructor(private el: ElementRef, private ref: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.getPlaceAutocomplete();
    }

    ngOnChanges(): void {
        this.getPlaceAutocomplete();
    }

    private getPlaceAutocomplete() {
        const autocomplete = new google.maps.places.Autocomplete(
            this.el.nativeElement,
            this.octoGooglePlacesAutocomplete?.googleAddressOptions
        );
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            const place = autocomplete.getPlace();
            if (place) {
                this.updateFormGroup(place);
            }
        });
    }

    private updateFormGroup(place: any): void {
        const temp = {
            address_line: this.getStreetNumber(place)
                ? `${this.getStreetNumber(place)} ${this.getStreet(place)}`
                : `${this.getStreet(place)}`,
            address_state: this.getState(place) || null,
            address_city: this.getCity(place) || null,
            address_apartment_suite_no: null,
            address_country: this.getCountryShort(place) || null,
            address_zip: this.getPostCode(place) || null,
            complete_address: place.formatted_address || null,
        };
        this.octoGooglePlacesAutocomplete.formGroup.patchValue({ ...temp });
        this.ref.detectChanges();
    }

    private isGooglePlace(place: any) {
        if (!place) return false;
        return !!place.place_id;
    }

    private isContainTypes(place: { types: any }, types: string | any[]) {
        var placeTypes, placeType, type;
        if (!this.isGooglePlace(place)) return false;
        placeTypes = place.types;
        for (var i = 0; i < types.length; i++) {
            type = types[i];
            for (var j = 0; j < placeTypes.length; j++) {
                placeType = placeTypes[j];
                if (placeType === type) {
                    return true;
                }
            }
        }
        return false;
    }

    private getAddrComponent(place: any, componentTemplate: any) {
        var result;
        if (!this.isGooglePlace(place)) return;
        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types;
            for (const element of addressType) {
                if (componentTemplate[element]) {
                    result =
                        place.address_components[i][componentTemplate[element]];
                    return result;
                }
            }
        }
        return result ? result : null;
    }

    private getPlaceId(place: any) {
        if (!this.isGooglePlace(place)) return;
        return place.place_id;
    }

    private getStreetNumber(place: any) {
        var COMPONENT_TEMPLATE = { street_number: 'short_name' },
            streetNumber = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return streetNumber ? streetNumber.toUpperCase() : streetNumber;
    }

    private getStreet(place: any) {
        var COMPONENT_TEMPLATE = { route: 'long_name' },
            street = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return street ? street.toUpperCase() : '';
    }

    private getCity(place: any) {
        var COMPONENT_TEMPLATE = { locality: 'long_name' },
            city = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return city ? city.toUpperCase() : city;
    }

    private getAptNo(place: any) {
        var COMPONENT_TEMPLATE = { subpremise: 'long_name' },
            apt = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return apt ? apt.toUpperCase() : apt;
    }

    private getState(place: any) {
        var COMPONENT_TEMPLATE = {
                administrative_area_level_1: 'short_name',
            },
            state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return state ? state.toUpperCase() : state;
    }

    private getDistrict(place: any) {
        var COMPONENT_TEMPLATE = {
                administrative_area_level_2: 'short_name',
            },
            state = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return state ? state.toUpperCase() : state;
    }

    private getCountryShort(place: any) {
        var COMPONENT_TEMPLATE = { country: 'short_name' },
            countryShort = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return countryShort ? countryShort.toUpperCase() : countryShort;
    }

    private getCountry(place: any) {
        var COMPONENT_TEMPLATE = { country: 'long_name' },
            country = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return country ? country.toUpperCase() : country;
    }

    private getPostCode(place: any) {
        var COMPONENT_TEMPLATE = { postal_code: 'long_name' },
            postCode = this.getAddrComponent(place, COMPONENT_TEMPLATE);
        return postCode ? postCode.toUpperCase() : postCode;
    }

    private isGeometryExist(place: any) {
        return typeof place === 'object' && typeof place.geometry === 'object';
    }

    private getLatitude(place: any) {
        if (!this.isGeometryExist(place)) return;
        return place.geometry.location.lat();
    }

    private getLongitude(place: any) {
        if (!this.isGeometryExist(place)) return;
        return place.geometry.location.lng();
    }
}
